import { OrdinaryObject } from "src/modules/utils/shared/ordinary-object.model";

export class UserSetInfoPriorToLoginDto {
    userName: string;
    password: string;
    data: OrdinaryObject;
}
